<template>
  <div
    class="chat-header"
    :class="{ dark }"
    @click="$emit('click')"
  >
    <img
      v-if="dark"
      src="../../assets/dark/patricia-logo.png"
      class="w-64"
    >
    <div
      v-else
      class="flex h-full items-center"
    >
      <div
        v-if="open"
        class="flex sm:hidden"
      >
        <img
          src="../../assets/down-arrow.png"
          class="h-4 mr-4"
        >
        <img
          src="../../assets/down-arrow.png"
          class="h-4 mr-4"
        >
      </div>
      <div
        v-else
        class="flex sm:hidden"
      >
        <img
          src="../../assets/up-arrow.png"
          class="h-4 mr-4"
        >
        <img
          src="../../assets/up-arrow.png"
          class="h-4 mr-4"
        >
      </div>
      <img
        src="../../assets/pat-logo-v-2-copy.png"
        class="mr-4 h-8 sm:h-16 px-8 sm:px-0"
      >
      <div
        v-if="open"
        class="flex sm:hidden"
      >
        <img
          src="../../assets/down-arrow.png"
          class="h-4 mr-4"
        >
        <img
          src="../../assets/down-arrow.png"
          class="h-4 mr-4"
        >
      </div>
      <div
        v-else
        class="flex sm:hidden"
      >
        <img
          src="../../assets/up-arrow.png"
          class="h-4 mr-4"
        >
        <img
          src="../../assets/up-arrow.png"
          class="h-4 mr-4"
        >
      </div>
      <img
        src="../../assets/eb-l-patricia-02.png"
        class="hidden sm:block"
      >
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'ChatHeader',

  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      dark: state => state.auth.dark,
    }),
  },
}
</script>

<style lang="postcss" scoped>
.chat-header {
  min-height: 44px;
  @apply bg-blue flex justify-center items-center relative cursor-pointer w-full z-10;

  &.dark {
    background-image: none;
    @apply bg-almost-black border border-blue justify-center py-4 px-8 text-center;

    &:hover {
      @apply bg-blue;
    }
  }
}

@screen sm {
  .chat-header {
    min-height: 89px;
    @apply bg-blue;
    &:hover {
      @apply bg-blue-lighter;
    }
  }
}
</style>
